module.exports = __webpack_public_path__ + "img/tip-icon.5dd011e0.png";